import { ObservableMap } from "mobx";
import type { ICache } from "../../../client/stores";
import * as Webapi from "../generated/webapi.g";
import { Cursor } from "../lib/cursor";
import { logger } from "../lib/logging";
import { sdk } from "./sdk";

const log = logger.getChild("Podcast Service");

export async function getPodcast(variables: Webapi.GetPodcastEpisodesQueryVariables, surrogateKeys: Set<string>) {
    surrogateKeys.add("ihr-amp");
    return sdk.GetPodcastEpisodes.queryAsPromise(variables).then(response => response.data?.amp.podcast);
}

export async function getPodcasts(podcastIds: string[], surrogateKeys: Set<string>) {
    const podcasts = await Promise.all(
        podcastIds.map(async podcastId => {
            try {
                return await getPodcast({ id: parseInt(podcastId, 10), paging: { take: 1 } }, surrogateKeys);
            } catch (err) {
                log.debug(`Loading podcast with id ${podcastId} has an error:`, err.message);
                return null;
            }
        }),
    );

    return podcasts.filter((podcast): podcast is Webapi.PodcastFragment => Boolean(podcast));
}

export function getPodcastEpisodes(
    variables: Webapi.GetPodcastEpisodesQueryVariables,
    cache: ObservableMap<string, ICache>,
) {
    return new Cursor<
        Webapi.PodcastEpisodesFragment | undefined,
        Webapi.GetPodcastEpisodesQueryVariables,
        Webapi.PodcastEpisodeFragment
    >(
        variables,
        async (query: Webapi.GetPodcastEpisodesQueryVariables) => {
            return sdk.GetPodcastEpisodes.queryAsPromise(query).then(response => response.data?.amp.podcast?.episodes);
        },
        (resp: Webapi.PodcastEpisodesFragment | undefined, opts: Webapi.GetPodcastEpisodesQueryVariables) => {
            const newData = resp?.items || [];
            const hasMore = resp?.pageInfo.nextCursor !== "";
            const newOpts = { ...opts, paging: { ...opts.paging, nextCursor: resp?.pageInfo.nextCursor || "" } };
            return { opts: newOpts, hasMore, newData };
        },
        (opts: Webapi.GetPodcastEpisodesQueryVariables) =>
            `getPodcastEpisodes-podcastId:${opts.id}-pageKey:${JSON.stringify(opts.paging)}`,
        cache,
    );
}
